import {
  TextField,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  InputLabel,
  Button,
  TablePagination,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import Layout from "../../components/layout/Layout";
import AddIcon from "@mui/icons-material/Add";
import ScheduleSendIcon from "@mui/icons-material/ScheduleSend";
import "./content.css";
import { useDispatch, useSelector } from "react-redux";
import SlowMotionVideoOutlinedIcon from "@mui/icons-material/SlowMotionVideoOutlined";
import {
  addContent,
  deleteContent,
  getContent,
  contentFlagOff,
  deleteContentSchedule,
  addContentSchedule,
  contentUpdate,
} from "../../Redux/Actions/contentAction";
import {
  LanguageOutlined,
  PhotoCameraBackOutlined,
} from "@mui/icons-material";
import Image from "./component/image";
import Vedio from "./component/vedio";
import Url from "./component/url";
import PrimarySearchBar from "../../components/searchBar/searchbar";
import { Box } from "@mui/system";
import DeleteModel from "../../components/deletemodel/DeleteModel";
import toast from "react-hot-toast";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import CloseIcon from "@mui/icons-material/Close";
import Pdf from "./component/Pdf";
import Loader from "../../components/loader/Loader";
import AppWidget from "./component/models/AppWidget";
import YoutubeWidget from "./widgets/youtube/YoutubeWidget";
import EmbedWidget from "./widgets/embed/EmbedWidget";
import AppWidgetForm from "./component/models/AppWidgetForm";
import WeatherWidget from "./widgets/weather/WeatherWidget";
import YoutubePlaylist from "./widgets/youtubeplaylist/YoutubePlaylist";
import Widget from "./component/Widget";
import Template from "./component/Template";
import { canEditCms } from "../../utils/accessControl";
import { useContextUserId } from "../../hooks/useSupportContext";

const appCompnent = {
  default: "",
  youtube: YoutubeWidget,
  youtubeplaylist: YoutubePlaylist,
  embed: EmbedWidget,
  weather: WeatherWidget,
};

function Content({ socketRef, user }) {
  const dispatch = useDispatch();
  const canEdit = canEditCms(user);
  const contextUserId = useContextUserId();
  const {
    content,
    isContentAdding,
    isContentScheduled,
    isContentScheduledDeleted,
    isContentLoading,
    isContentAdded,
    isDeleted,
    isContentLoaded,
    pagination,
  } = useSelector((state) => state.Content);
  const [pdfForm, setPdfForm] = useState(false);
  const [openMediaPop, setOpenMediaPop] = useState(false);
  const [openEditUrlModel, setOpenEditUrlModel] = useState(false);
  const [ids, setIds] = useState("");
  const [urlContentForm, setUrlContentForm] = useState(false);
  const [urlName, setUrlName] = useState("");
  const [pdfInput, setPdfInput] = useState({
    thumbnail: "",
    thumbnailFile: "",
    pdfThumbnail: "",
    pdfFile: "",
  });
  const [urlContent, setUrlContent] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [contentFilter, setContentFilter] = useState("all");
  const [openDialog, setOpenDialog] = useState(false);
  const [contentDeleteId, setContentDeleteId] = useState("");
  const [searchText, setSearchText] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [contentID, setContentID] = useState("");
  const [openSchedule, setOpenSchedule] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [day, setDay] = useState([]);
  const [isScheduled, setIsScheduled] = useState(false);
  const [scheduleInfo, setScheduleInfo] = useState({});
  const [openWidgets, setOpenWidgets] = useState(false);
  const [openWidgetForm, setOpenWidgetForm] = useState(false);
  const [widgetKey, setWidgetKey] = useState("default");
  const [isDragOverUpload, setIsDragOverUpload] = useState(false);
  const prevLoadingRef = useRef(false);
  const isSearchInitialMount = useRef(true);
  const contentGridRef = useRef(null);
  const [contentPageReady, setContentPageReady] = useState(false);
  const AppComponent = appCompnent[widgetKey];
  const [days, setDays] = useState([
    { _id: 1, day: "Mon", dayChecked: false },
    { _id: 2, day: "Tue", dayChecked: false },
    { _id: 3, day: "Wed", dayChecked: false },
    { _id: 4, day: "Thu", dayChecked: false },
    { _id: 5, day: "Fri", dayChecked: false },
    { _id: 6, day: "Sat", dayChecked: false },
    { _id: 7, day: "Sun", dayChecked: false },
  ]);
  useEffect(() => {
    if (!contextUserId) return;
    setCurrentPage(1);
    setContentPageReady(false);
    socketRef.current.emit("leaving--connection");
    dispatch(
      getContent(contextUserId, {
        page: 1,
        limit: itemsPerPage,
        type: contentFilter === "all" ? "" : contentFilter,
        search: searchTerm,
      })
    );
  }, [contextUserId]);

  useEffect(() => {
    if (isContentLoading) {
      prevLoadingRef.current = true;
    } else {
      if (prevLoadingRef.current) {
        setContentPageReady(true);
        prevLoadingRef.current = false;
      }
    }
  }, [isContentLoading]);

  const loadContent = (page = currentPage, limit = itemsPerPage, search = searchTerm, type = contentFilter === "all" ? "" : contentFilter) => {
    dispatch(getContent(contextUserId, { page, limit, type: type || "", search }));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    setContentPageReady(false);
    loadContent(page, itemsPerPage, searchTerm, contentFilter === "all" ? "" : contentFilter);
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
    setContentPageReady(false);
    loadContent(1, newItemsPerPage, searchTerm, contentFilter === "all" ? "" : contentFilter);
  };

  const handleSearch = (search) => {
    setSearchTerm(search);
    setCurrentPage(1);
    setContentPageReady(false);
    loadContent(1, itemsPerPage, search, contentFilter === "all" ? "" : contentFilter);
  };

  const handleFilterChange = (type) => {
    setContentFilter(type);
    setCurrentPage(1);
    setContentPageReady(false);
    loadContent(1, itemsPerPage, searchTerm, type === "all" ? "" : type);
  };
  useEffect(() => {
    if (isContentAdded) {
      // Re-sync from API so pagination matches server (newest-first). Client-only appends +
      // slice() were hiding new items or making older rows disappear on page 1.
      if (contextUserId) {
        setCurrentPage(1);
        setContentPageReady(false);
        dispatch(
          getContent(contextUserId, {
            page: 1,
            limit: itemsPerPage,
            type: contentFilter === "all" ? "" : contentFilter,
            search: searchTerm,
          })
        );
      }
      dispatch(contentFlagOff());
    }
    if (isDeleted) {
      dispatch(contentFlagOff());
    }
    if (isContentScheduled) {
      toast.success("Playlist have scheduled");
      setIsScheduled(false);
      // const _checkingScreenAssing = screens.find(
      //   (s) => s.playlist?._id === playlistId
      // );
      // if (_checkingScreenAssing !== undefined) {
      //   emitOnScheduleAdd(_checkingScreenAssing.mac);
      // }
      dispatch(contentFlagOff());
    }
    if (isContentScheduledDeleted) {
      setOpenSchedule(false);
      toast.success("schedule deleted successfully");
      setIsScheduled(false);
      // const __checkingScreenAssing = screens.find(
      //   (s) => s.playlist?._id === playlistId
      // );
      // if (__checkingScreenAssing !== undefined) {
      //   emitOnScheduleAdd(__checkingScreenAssing.mac);
      // }
      dispatch(contentFlagOff());
    }
  }, [
    isContentAdded,
    isDeleted,
    isContentScheduled,
    isContentScheduledDeleted,
  ]);
  const handleClick = () => {
    // 👇️ toggle
    setIsActive((current) => !current);

    // 👇️ or set to true
    // setIsActive(true);
  };

  const uploadMediaFiles = (files) => {
    if (!files || files.length === 0) return;
    const form = new FormData();
    files.forEach((file) => form.append("content", file));
    form.append("role", user?.role);
    form.append("userId", contextUserId);
    // form.append("userId", user?.role === "admin" && user?._id);
    // form.append("subuser", user?.role === "user" && user?._id);
    dispatch(addContent(form));
    closeAddContentPopup();
  };
  const fileHandler = (e) => {
    const files = Array.from(e.target.files || []);
    uploadMediaFiles(files);
    e.target.value = "";
  };
  const handleUploadDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "copy";
    if (!isDragOverUpload) {
      setIsDragOverUpload(true);
    }
  };
  const handleUploadDragLeave = (e) => {
    e.preventDefault();
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setIsDragOverUpload(false);
    }
  };
  const handleUploadDrop = (e) => {
    e.preventDefault();
    setIsDragOverUpload(false);
    const droppedFiles = Array.from(e.dataTransfer?.files || []);
    if (droppedFiles.length === 0) return;
    const supportedFiles = droppedFiles.filter(
      (file) => file.type?.startsWith("image/") || file.type === "video/mp4"
    );
    if (supportedFiles.length === 0) {
      toast.error("Only image and MP4 video files can be uploaded here.");
      return;
    }
    if (supportedFiles.length !== droppedFiles.length) {
      toast.error("Some files were skipped because they are not supported.");
    }
    uploadMediaFiles(supportedFiles);
  };
  const urlContentSubmit = () => {
    const cleanName = urlName.trim();
    const cleanUrl = urlContent.trim();
    const normalizedUrl = /^https?:\/\//i.test(cleanUrl)
      ? cleanUrl
      : `https://${cleanUrl}`;

    const form = new FormData();
    form.append("name", cleanName);
    form.append("contenttype", "url");
    form.append("url", normalizedUrl);
    form.append("role", user?.role);
    form.append("userId", contextUserId);
    form.append("subuser", user?._id);
    dispatch(addContent(form));
    closeAddContentPopup();
  };
  const pdfContentSubmit = () => {
    const form = new FormData();
    form.append("pdf", pdfInput.pdfFile);
    form.append("thumbnail", pdfInput.thumbnailFile);
    // form.append("url", urlContent);
    form.append("role", user?.role);
    form.append("userId", contextUserId);
    form.append("subuser", user?._id);
    dispatch(addContent(form));
    closeAddContentPopup();
  };
  const handleDeleteContent = (id) => {
    // console.log(id)
    setOpenDialog(true);
    setContentDeleteId(id);
  };
  const confirmDeleteContent = () => {
    dispatch(deleteContent(contentDeleteId));
    setOpenDialog(false);
  };
  const searchHandler = (e) => {
    setSearchText(e);
  };

  useEffect(() => {
    // Skip first run on mount to avoid duplicate load with initial effect
    if (isSearchInitialMount.current) {
      isSearchInitialMount.current = false;
      return;
    }
    const timer = setTimeout(() => {
      handleSearch(searchText?.trim() || "");
    }, 400);

    return () => clearTimeout(timer);
  }, [searchText]);

  const addSchedule = (contentid) => {
    const info = content.find((c) => c.id === contentid);
    // console.log('from addSchedule=>',info)
    const __startDate = new Date(info?.schedule?.startDate)
      .toLocaleDateString()
      .split("/");
    const __endDate = new Date(info?.schedule?.endDate)
      .toLocaleDateString()
      .split("/");
    const isStartDateOneDigit = [1, 2, 3, 4, 5, 6, 7, 8, 9].find(
      (digit) => digit == __startDate[0]
    );
    const isEndDateOneDigit = [1, 2, 3, 4, 5, 6, 7, 8, 9].find(
      (digit) => digit == __endDate[0]
    );
    const _startDate = `${__startDate[2]}-${
      isStartDateOneDigit !== undefined
        ? "0" + isStartDateOneDigit
        : __startDate[0]
    }-${__startDate[1]}`.toString();
    const _endDate = `${__endDate[2]}-${
      isEndDateOneDigit !== undefined ? "0" + isEndDateOneDigit : __endDate[0]
    }-${__endDate[1]}`.toString();
    if (info?.schedule?.scheduled) {
      setIsScheduled(true);
      // console.log("inside condition=>", info);
    }
    setContentID(contentid);
    setStartDate(_startDate);
    setEndDate(_endDate);
    setStartTime(info?.schedule?.startTime);
    setEndTime(info?.schedule?.endTime);
    setOpenSchedule(true);
    const dbDay = info.schedule.days;
    // console.log(dbDay)
    const sameArray = days.filter(
      (item) => !dbDay.find((d) => d.day === item.day)
    );
    // console.log([...sameArray,...dbDay]);
    setDays([...sameArray, ...dbDay]);
    setDay([...dbDay]);
  };

  const saveSchedule = () => {
    // console.log(day);
    dispatch(
      addContentSchedule(contentID, {
        startDate,
        endDate,
        startTime,
        endTime,
        days: day,
      })
    );
    setDay([]);
    setOpenSchedule(false);
  };
  const deleteScheduleFromContent = (id) => {
    dispatch(deleteContentSchedule(id));
  };
  const emitOnScheduleAdd = (mac) => {
    const id = setTimeout(() => {
      socketRef.current?.emit("update_duration", { detail: { mac: mac } });
      clearTimeout(id);
    }, 2000);
  };
  const cancelSchedule = () => {
    setOpenSchedule(false);
    // console.log([...days]);
    setDay([]);
    setDays([
      { _id: 1, day: "Mon", dayChecked: false },
      { _id: 2, day: "Tue", dayChecked: false },
      { _id: 3, day: "Wed", dayChecked: false },
      { _id: 4, day: "Thu", dayChecked: false },
      { _id: 5, day: "Fri", dayChecked: false },
      { _id: 6, day: "Sat", dayChecked: false },
      { _id: 7, day: "Sun", dayChecked: false },
    ]);
  };
  const handleDayCheckbox = (e) => {
    const { name, checked, value } = e.target;
    // console.log(name,checked,value,days)
    if (checked) {
      setDay((prev) => [...prev, { day: value, dayChecked: true }]);
      const selectedDayIndex = days.findIndex((d) => d._id == name);
      days[selectedDayIndex] = { ...days[selectedDayIndex], dayChecked: true };
      setDays([...days]);
      // console.log(selectedDayIndex)
    } else {
      setDay((prev) => [...day.filter((d) => d.day !== value)]);
      const selectedDayIndex = days.findIndex((d) => d._id == name);
      days[selectedDayIndex] = { ...days[selectedDayIndex], dayChecked: false };
      // console.log(selectedDayIndex)
      setDays([...days]);
    }
    // console.log('days array=>',days)
  };

  const onEditContent = (_contentData) => {
    //  console.log(_contentData)
    setIds(_contentData.id);
    setUrlName(_contentData.name);
    setUrlContent(_contentData.url);
    setOpenEditUrlModel(true);
  };
  const urlContentUpdate = () => {
    const cleanName = urlName.trim();
    const cleanUrl = urlContent.trim();
    const normalizedUrl = /^https?:\/\//i.test(cleanUrl)
      ? cleanUrl
      : `https://${cleanUrl}`;

    dispatch(contentUpdate(ids, { url: normalizedUrl, name: cleanName }));
    closeEditUrlPopup();
  };

  const onOpenWidgetForm = (_key) => {
    setWidgetKey(_key);
    setOpenWidgetForm(true);
    setOpenWidgets(false);
  };

  const closeAddContentPopup = () => {
    setOpenMediaPop(false);
    setUrlContentForm(false);
    setPdfForm(false);
    setIsDragOverUpload(false);
    setUrlName("");
    setUrlContent("");
  };

  const closeEditUrlPopup = () => {
    setOpenEditUrlModel(false);
    setUrlName("");
    setUrlContent("");
    setIds("");
  };

  const openUrlForm = () => {
    setUrlContentForm(true);
    setPdfForm(false);
  };

  const openPdfForm = () => {
    setPdfForm(true);
    setUrlContentForm(false);
  };
  return (
    <Layout title="Content" user={user}>
      {/* <iframe width="720" height="405" src="https://www.youtube.com/embed/?listType=playlist&list=PLxf3-FrL8GzTLaDiaApnrXeFVlUoUFjQz" frameborder="0" allowfullscreen></iframe> */}
      <div className="parent-container">
        <div className="child-container">
          <Grid container>
            <Box className={"ct-control-area"}>
              <Box className="ct-search-card">
                <div className="ct-search-head">
                  <div className="ct-search-input-wrap">
                    <PrimarySearchBar
                      value={searchText}
                      onChange={searchHandler}
                    />
                  </div>
                  {canEdit && (
                    <div className="ct-user-add-btn">
                      <button onClick={() => setOpenMediaPop(true)}>
                        <AddIcon /> Add Content
                      </button>
                    </div>
                  )}
                </div>
                <div className="content-filter-toolbar content-filter-toolbar--inside">
                  <div className="pl-toolbar-filters">
                    <div className="pl-filter-group">
                      <label htmlFor="ct-type-filter" className="ct-filter-select-label">Type</label>
                      <select
                        id="ct-type-filter"
                        className="pl-filter-select"
                        value={contentFilter}
                        onChange={(e) => handleFilterChange(e.target.value)}
                      >
                        <option value="all">All</option>
                        <option value="image">Image</option>
                        <option value="video">Video</option>
                        <option value="url">Webpage</option>
                      </select>
                    </div>
                  </div>
                </div>
              </Box>
            </Box>
          </Grid>
        </div>
        {isContentAdding && (
          <>
            <Box
              sx={{
                position: "absolute",
                height: "100vh",
                width: "100vw",
                background: "rgba(0,0,0,0.5)",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: "1000000",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Loader />
            </Box>
          </>
        )}

        <div className="fl-table-card">
          {!contentPageReady ? (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "60px 0" }}>
              <Loader />
            </div>
          ) : (
            <>
          <div ref={contentGridRef} className="content-render flex flex-wrap justifyContentCenter alignItemCenter margin ct-content-grid">
          {(() => {
            const filtered =
              contentFilter === "all"
                ? content.filter(
                    (item) =>
                      item.type === "image" ||
                      item.type === "video" ||
                      item.type === "url" ||
                      item.type === "application" ||
                      item.type === "template"
                  )
                : content.filter((item) => item.type === contentFilter);
            const start = (currentPage - 1) * itemsPerPage;
            const end = start + itemsPerPage;
            const displayContent =
              filtered.length > itemsPerPage ? filtered.slice(start, end) : filtered;
            return displayContent.length > 0 ? (
              displayContent.map((item, index) => {
                const itemKey = item.id || item._id || `${item.type}-${item.name}-${index}`;
                if (item.type === "image") {
                  return (
                    <Image
                      key={itemKey}
                      data={item}
                      addSchedule={addSchedule}
                      deleteSingleContent={handleDeleteContent}
                      readOnly={!canEdit}
                    />
                  );
                }
                if (item.type === "video") {
                  return (
                    <Vedio
                      key={itemKey}
                      data={item}
                      addSchedule={addSchedule}
                      deleteSingleContent={handleDeleteContent}
                      readOnly={!canEdit}
                    />
                  );
                }
                if (item.type === "url") {
                  return (
                    <Url
                      key={itemKey}
                      data={item}
                      addSchedule={addSchedule}
                      deleteSingleContent={handleDeleteContent}
                      editContent={onEditContent}
                      readOnly={!canEdit}
                    />
                  );
                }
                if (item.type === "application") {
                  return (
                    <Pdf
                      key={itemKey}
                      data={item}
                      addSchedule={addSchedule}
                      deleteSingleContent={handleDeleteContent}
                      readOnly={!canEdit}
                    />
                  );
                }
                if (item.type === "template") {
                  return (
                    <Template
                      key={itemKey}
                      data={item}
                      addSchedule={addSchedule}
                      deleteSingleContent={handleDeleteContent}
                      readOnly={!canEdit}
                    />
                  );
                }
                return null;
              })
            ) : (
              <div className="no-content">
                <p>No content found</p>
              </div>
            );
          })()}
          </div>

          {/* Pagination – same as dd-ten (MUI TablePagination with borderTop) */}
          <TablePagination
            rowsPerPageOptions={[5, 10, 20, 50, 100]}
            component="div"
            count={pagination?.totalItems ?? content.length ?? 0}
            rowsPerPage={itemsPerPage}
            page={Math.max(0, currentPage - 1)}
            onPageChange={(e, newPage) => {
              handlePageChange(newPage + 1);
              contentGridRef.current?.scrollIntoView?.({ behavior: 'smooth', block: 'start' });
            }}
            onRowsPerPageChange={(e) =>
              handleItemsPerPageChange(parseInt(e.target.value, 10))
            }
            sx={{
              borderTop: "1px solid #f0f0f0",
              fontFamily: "'Open Sans', sans-serif",
              "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
                fontSize: "12px",
                fontFamily: "'Open Sans', sans-serif",
              },
            }}
          />
            </>
          )}
        </div>
      </div>

      <Dialog
        sx={{ zIndex: "10000000000000" }}
        open={openSchedule}
        onClose={() => setOpenSchedule(false)}
        maxWidth={"lg"}
      >
        <DialogTitle
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "700",
            marginBottom: "30px",
            // paddingBottom: '18px',
            borderBottom: "3px solid #008080",
          }}
        >
          <ScheduleSendIcon sx={{ color: "#008080" }} /> Schedule
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              height: "50vh",
              width: "30vw",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                height: "97%",
                width: "97%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  height: "20%",
                  width: "100%",
                  display: "flex",
                  gap: "10px",
                  border: "1px solid transparent",
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <InputLabel htmlFor="start-date">Start Date</InputLabel>
                  <TextField
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    id={"start-date"}
                    type={"date"}
                    fullWidth
                  />
                </Box>

                <Box sx={{ flex: 1 }}>
                  <InputLabel htmlFor="end-date">End Date</InputLabel>
                  <TextField
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    id={"end-date"}
                    type={"date"}
                    fullWidth
                  />
                </Box>
              </Box>

              <Box
                sx={{
                  height: "20%",
                  width: "100%",
                  display: "flex",
                  gap: "10px",
                  border: "1px solid transparent",
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <InputLabel htmlFor="start-time">Start Time</InputLabel>
                  <TextField
                    value={startTime}
                    onChange={(e) => setStartTime(e.target.value)}
                    id={"start-time"}
                    type={"time"}
                    fullWidth
                  />
                </Box>

                <Box sx={{ flex: 1 }}>
                  <InputLabel htmlFor="end-time">End Time</InputLabel>
                  <TextField
                    value={endTime}
                    onChange={(e) => setEndTime(e.target.value)}
                    id={"end-time"}
                    type={"time"}
                    fullWidth
                  />
                </Box>
              </Box>

              <Box
                id={"days-id"}
                sx={{
                  minHeight: "20%",
                  margin: "10px 0",
                  width: "100%",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "5px",
                }}
              >
                {days.map((d, index) => {
                  return (
                    <React.Fragment key={d._id || d.day || index}>
                      <input
                        onChange={handleDayCheckbox}
                        name={d._id}
                        value={d.day}
                        checked={d.dayChecked ? true : false}
                        type={"checkbox"}
                        id={`day-${index}`}
                        style={{ display: "none" }}
                      />
                      <label
                        htmlFor={`day-${index}`}
                        style={{
                          cursor: "pointer",
                          borderRadius: "10px",
                          height: "50px",
                          width: "80px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          border: "1px solid black",
                        }}
                      >
                        {d.day}
                      </label>
                    </React.Fragment>
                  );
                })}
              </Box>

              <Box
                sx={{
                  minHeight: "20%",
                  margin: "10px 0",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "5px",
                }}
              >
                <Button
                  variant={"outlined"}
                  type="button"
                  sx={{
                    width: "100px",
                  }}
                  onClick={cancelSchedule}
                >
                  Cancel
                </Button>
                <Button
                  variant={"contained"}
                  type="button"
                  sx={{
                    width: "100px",
                  }}
                  onClick={saveSchedule}
                >
                  Save
                </Button>
                {isScheduled ? (
                  <>
                    <Button
                      variant="contained"
                      color={"error"}
                      onClick={() => deleteScheduleFromContent(contentID)}
                    >
                      Delete
                    </Button>
                  </>
                ) : (
                  <></>
                )}
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      <DeleteModel
        open={openDialog}
        onClose={(e) => setOpenDialog(e)}
        onConfirm={confirmDeleteContent}
        title="Delete content"
        message="Are you sure you want to delete this content? This action cannot be undone."
      />

      <AppWidget
        maxWidth={"md"}
        isFullWidth={true}
        isOpen={openWidgets}
        onClose={() => setOpenWidgets(false)}
        onOpenWidgetForm={onOpenWidgetForm}
      />

      <AppWidgetForm
        maxWidth={"lg"}
        // isFullWidth={true}
        isOpen={openWidgetForm}
        onClose={() => {
          setOpenWidgetForm(false);
          setOpenWidgets(true);
        }}
      >
        <AppComponent
          onClose={() => {
            setOpenWidgetForm(false);
            setOpenWidgets(true);
          }}
        />
      </AppWidgetForm>

      <Dialog
        maxWidth="xs"
        fullWidth={true}
        open={openMediaPop}
        onClose={closeAddContentPopup}
        sx={{ zIndex: "100000000" }}
        PaperProps={{ sx: { borderRadius: "12px", overflow: "hidden" } }}
      >
        <DialogTitle
          sx={{
            fontFamily: "'Open Sans', sans-serif",
            fontSize: "15px",
            fontWeight: 600,
            color: "#1a202c",
            textAlign: "center",
            borderBottom: "1px solid #edf2f7",
            pb: "12px",
            position: "relative",
          }}
        >
          {urlContentForm ? "Add URL" : pdfForm ? "Add PDF" : "Add Content"}
          <CloseIcon
            onClick={closeAddContentPopup}
            sx={{
              position: "absolute",
              right: 16,
              top: 16,
              fontSize: "20px",
              color: "#a0aec0",
              cursor: "pointer",
              "&:hover": { color: "#e53e3e" },
            }}
          />
        </DialogTitle>
        <DialogContent sx={{ p: "20px 24px !important" }}>
          {!urlContentForm && !pdfForm && (
            <Box
              sx={{ display: "flex", flexDirection: "column", gap: "10px", mt: 1 }}
              className={`ct-upload-dropzone ${isDragOverUpload ? "is-drag-over" : ""}`}
              onDragOver={handleUploadDragOver}
              onDragEnter={handleUploadDragOver}
              onDragLeave={handleUploadDragLeave}
              onDrop={handleUploadDrop}
            >
              <div className="ct-upload-dropzone__hint">
                Drag and drop image/video files here
              </div>
              <input
                type="file"
                hidden
                id="photo"
                multiple
                accept="image/jpeg,image/png,image/gif,image/webp,video/mp4"
                onChange={fileHandler}
              />
              <label htmlFor="photo" className="ct-add-media-option">
                <Box sx={{ width: 40, height: 40, borderRadius: "10px", background: "rgba(57,191,89,0.1)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <PhotoCameraBackOutlined sx={{ fontSize: 20, color: "var(--primary-color)" }} />
                </Box>
                <Box>
                  <span className="ct-add-media-title">Image</span>
                  <span className="ct-add-media-desc">Upload image content</span>
                </Box>
              </label>
              <label htmlFor="photo" className="ct-add-media-option">
                <Box sx={{ width: 40, height: 40, borderRadius: "10px", background: "rgba(102,126,234,0.1)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <SlowMotionVideoOutlinedIcon sx={{ fontSize: 20, color: "#667eea" }} />
                </Box>
                <Box>
                  <span className="ct-add-media-title">Video</span>
                  <span className="ct-add-media-desc">Upload video content</span>
                </Box>
              </label>
              <button className="ct-add-media-option ct-reset-btn" onClick={openUrlForm}>
                <Box sx={{ width: 40, height: 40, borderRadius: "10px", background: "rgba(237,137,54,0.1)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <LanguageOutlined sx={{ fontSize: 20, color: "#ed8936" }} />
                </Box>
                <Box sx={{ textAlign: "left" }}>
                  <span className="ct-add-media-title">URL</span>
                  <span className="ct-add-media-desc">Add URL link content</span>
                </Box>
              </button>
              <button className="ct-add-media-option ct-reset-btn" onClick={openPdfForm}>
                <Box sx={{ width: 40, height: 40, borderRadius: "10px", background: "rgba(229,62,62,0.1)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <PictureAsPdfOutlinedIcon sx={{ fontSize: 20, color: "#e53e3e" }} />
                </Box>
                <Box sx={{ textAlign: "left" }}>
                  <span className="ct-add-media-title">PDF</span>
                  <span className="ct-add-media-desc">Upload PDF document</span>
                </Box>
              </button>
            </Box>
          )}

          {pdfForm && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: "16px", mt: 1 }}>
              <input
                type={"file"}
                id={"thumbnail"}
                style={{ border: "none" }}
                onChange={(e) =>
                  setPdfInput((prev) => ({
                    ...prev,
                    thumbnail: e.target.files[0].name,
                    thumbnailFile: e.target.files[0],
                  }))
                }
                hidden
              />
              <input
                type={"file"}
                id={"pdffile"}
                style={{ border: "none" }}
                onChange={(e) =>
                  setPdfInput((prev) => ({
                    ...prev,
                    pdfThumbnail: e.target.files[0].name,
                    pdfFile: e.target.files[0],
                  }))
                }
                hidden
              />
              <label htmlFor="thumbnail" className="ct-add-media-option">
                <Box sx={{ width: 40, height: 40, borderRadius: "10px", background: "rgba(49,130,206,0.1)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <PhotoCameraBackOutlined sx={{ fontSize: 20, color: "#3182ce" }} />
                </Box>
                <Box>
                  <span className="ct-add-media-title">
                    {pdfInput.thumbnail == "" ? "Select Thumbnail" : pdfInput.thumbnail?.substring(0, 28)}
                  </span>
                  <span className="ct-add-media-desc">Preview image</span>
                </Box>
              </label>
              <label htmlFor="pdffile" className="ct-add-media-option">
                <Box sx={{ width: 40, height: 40, borderRadius: "10px", background: "rgba(229,62,62,0.1)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <PictureAsPdfOutlinedIcon sx={{ fontSize: 20, color: "#e53e3e" }} />
                </Box>
                <Box>
                  <span className="ct-add-media-title">
                    {pdfInput.pdfThumbnail == "" ? "Select PDF File" : pdfInput.pdfThumbnail?.substring(0, 28)}
                  </span>
                  <span className="ct-add-media-desc">Document file</span>
                </Box>
              </label>
              <Box sx={{ display: "flex", justifyContent: "flex-end", gap: "8px", pt: 1 }}>
                <Button
                  variant="outlined"
                  onClick={() => setPdfForm(false)}
                  sx={{ fontFamily: "'Open Sans', sans-serif", fontSize: "13px", fontWeight: 500, color: "#4a5568", borderColor: "#e2e8f0", borderRadius: "8px", textTransform: "none", "&:hover": { borderColor: "#cbd5e0", background: "#f7fafc" } }}
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  onClick={pdfContentSubmit}
                  disabled={!pdfInput.thumbnailFile || !pdfInput.pdfFile}
                  sx={{ fontFamily: "'Open Sans', sans-serif", fontSize: "13px", fontWeight: 500, background: "var(--primary-color)", borderRadius: "8px", textTransform: "none", boxShadow: "none", "&:hover": { boxShadow: "none", opacity: 0.9 } }}
                >
                  Save
                </Button>
              </Box>
            </Box>
          )}

          {urlContentForm && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: "16px", mt: 1 }}>
              <TextField
                variant="outlined"
                size="small"
                value={urlName}
                onChange={(e) => setUrlName(e.target.value)}
                label="Title"
                placeholder="Company Website"
                fullWidth
                sx={{ "& .MuiInputBase-root": { fontFamily: "'Open Sans', sans-serif", fontSize: "13px", borderRadius: "8px" }, "& .MuiInputLabel-root": { fontFamily: "'Open Sans', sans-serif", fontSize: "13px" } }}
              />
              <TextField
                variant="outlined"
                size="small"
                value={urlContent}
                onChange={(e) => setUrlContent(e.target.value)}
                label="URL Link"
                placeholder="https://example.com"
                fullWidth
                sx={{ "& .MuiInputBase-root": { fontFamily: "'Open Sans', sans-serif", fontSize: "13px", borderRadius: "8px" }, "& .MuiInputLabel-root": { fontFamily: "'Open Sans', sans-serif", fontSize: "13px" } }}
              />
              <Box sx={{ display: "flex", justifyContent: "flex-end", gap: "8px", pt: 1 }}>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setUrlContentForm(false);
                    setUrlName("");
                    setUrlContent("");
                  }}
                  sx={{ fontFamily: "'Open Sans', sans-serif", fontSize: "13px", fontWeight: 500, color: "#4a5568", borderColor: "#e2e8f0", borderRadius: "8px", textTransform: "none", "&:hover": { borderColor: "#cbd5e0", background: "#f7fafc" } }}
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  onClick={urlContentSubmit}
                  disabled={!urlName?.trim() || !urlContent?.trim()}
                  sx={{ fontFamily: "'Open Sans', sans-serif", fontSize: "13px", fontWeight: 500, background: "var(--primary-color)", borderRadius: "8px", textTransform: "none", boxShadow: "none", "&:hover": { boxShadow: "none", opacity: 0.9 } }}
                >
                  Save
                </Button>
              </Box>
            </Box>
          )}
        </DialogContent>
      </Dialog>

      <Dialog
        maxWidth="sm"
        fullWidth={true}
        open={openEditUrlModel}
        onClose={closeEditUrlPopup}
      >
        <DialogTitle
          sx={{
            fontFamily: "'Open Sans', sans-serif",
            fontSize: "15px",
            fontWeight: 600,
            color: "#1a202c",
            textAlign: "center",
            borderBottom: "1px solid #edf2f7",
            pb: "12px",
            position: "relative",
          }}
        >
          Edit URL
          <CloseIcon
            onClick={closeEditUrlPopup}
            sx={{
              position: "absolute",
              right: 16,
              top: 16,
              fontSize: "20px",
              color: "#a0aec0",
              cursor: "pointer",
              "&:hover": { color: "#e53e3e" },
            }}
          />
        </DialogTitle>
        <DialogContent sx={{ p: "20px 24px !important" }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "16px", mt: 1 }}>
              <TextField
                variant="outlined"
                size="small"
                value={urlName}
                onChange={(e) => setUrlName(e.target.value)}
                label="Title"
                placeholder="Company Website"
                fullWidth
                sx={{ "& .MuiInputBase-root": { fontFamily: "'Open Sans', sans-serif", fontSize: "13px", borderRadius: "8px" }, "& .MuiInputLabel-root": { fontFamily: "'Open Sans', sans-serif", fontSize: "13px" } }}
              />
              <TextField
                variant="outlined"
                size="small"
                value={urlContent}
                onChange={(e) => setUrlContent(e.target.value)}
                label="URL Link"
                placeholder="https://example.com"
                fullWidth
                sx={{ "& .MuiInputBase-root": { fontFamily: "'Open Sans', sans-serif", fontSize: "13px", borderRadius: "8px" }, "& .MuiInputLabel-root": { fontFamily: "'Open Sans', sans-serif", fontSize: "13px" } }}
              />
              <Box sx={{ display: "flex", justifyContent: "flex-end", gap: "8px", pt: 1 }}>
                <Button
                  variant="outlined"
                  onClick={closeEditUrlPopup}
                  sx={{ fontFamily: "'Open Sans', sans-serif", fontSize: "13px", fontWeight: 500, color: "#4a5568", borderColor: "#e2e8f0", borderRadius: "8px", textTransform: "none", "&:hover": { borderColor: "#cbd5e0", background: "#f7fafc" } }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  disabled={!urlName?.trim() || !urlContent?.trim()}
                  onClick={urlContentUpdate}
                  sx={{ fontFamily: "'Open Sans', sans-serif", fontSize: "13px", fontWeight: 500, background: "var(--primary-color)", borderRadius: "8px", textTransform: "none", boxShadow: "none", "&:hover": { boxShadow: "none", opacity: 0.9 } }}
                >
                  Update
                </Button>
              </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </Layout>
  );
}

export default Content;
